import * as React from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { createFilterOptions } from "@mui/material/Autocomplete";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import type { SxProps } from "@mui/material/styles";

import AutocompleteFormField from "components/autocomplete-form-field";
import { AGING_GROUPS } from "constants/sales";

type SelectAgingGroupProps = {
  onOptionSelected?: (
    option:
      | { label: string; value: string }
      | { label: string; value: string }[]
      | null
  ) => void;
  multiple?: boolean;
  sx?: SxProps;
};

export type RhfSelectAgingGroupProps<T extends FieldValues> =
  SelectAgingGroupProps & UseControllerProps<T>;

export default function SelectAgingGroup<T extends FieldValues>({
  control,
  name,
  onOptionSelected,
  multiple = false,
  sx = {}
}: RhfSelectAgingGroupProps<T>) {
  const filterOptions = createFilterOptions({
    stringify: (option: { label: string; value: string }) => option.label
  });

  return (
    <AutocompleteFormField
      openOnFocus
      autoHighlight
      autoFocus
      multiple={multiple}
      name={name}
      label="By Aging Group"
      options={AGING_GROUPS.getOptions()}
      filterOptions={filterOptions}
      getOptionLabel={(option) => {
        return option?.label ?? "";
      }}
      renderOption={(props: object, option: any) => (
        <ListItem {...props}>
          <ListItemText>{option.label}</ListItemText>
        </ListItem>
      )}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      popupIcon={<ArrowDropDownIcon />}
      control={control}
      onOptionSelected={(option: any) => {
        if (onOptionSelected) {
          onOptionSelected(option);
        }
      }}
      sx={{ ml: 0.5, mt: 0, minWidth: 150, ...sx }}
    />
  );
}
